/* tslint:disable */
/* eslint-disable */
/**
 * B2B Lodging
 * Endpoints to support Lodging  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.volume`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.lodging.cancel.policy.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `tenantid` * `b2bportal.lodging.cancel.policy.success`   * tags: `api_version`, `cancel_scenario`, `tenantid` * `b2bportal.lodging.change.policy.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `tenantid` * `b2bportal.lodging.change.policy.success`   * tags: `api_version`, `cancel_scenario`, `tenantid` * `b2bportal.lodging.room_shop.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.lodging.room_shop.success`   * tags: `api_version`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `bad_request` * `client_not_defined` * `frequent_guest_number_required` * `internal_error` * `invalid_quote` * `lack_of_inventory` * `minimum_check_in_age_not_met` * `offer_not_found` * `payment_failed` * `product_not_found` * `provider_not_defined` * `quote_expired` * `rate_not_available` * `request_deserialization_error` * `response_serialization_error` * `unavailable` * `unknown` * `unspecified`  # Cancel Scenarios * `canceled` * `cancellation_failure` * `complex_fully_refundable` * `complex_partially_refundable` * `contact_customer_service` * `full_refund` * `non_refundable` * `partial_refund` * `pending`
 *
 * The version of the OpenAPI document: v5p128
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

/**
 *
 * @export
 */
export const operationServerMap: ServerMap = {
}
